import gql from 'graphql-tag';

export const GET_COMBINADOS_BY_FILTER = gql(`
  query listadoCombinadosByFilter($filter: [String], $sort: [String], $page: Int!, $size: Int!) {
    listadoCombinadosByFilter(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
      totalElements
      firstElement
      results {
        id
        tipo
        nombre
        fechaFin
        contadorUsos
        numeroUsos
        avisadoPorcentajeUsos
        avisoAlPorcentajeUsos
        contrato{
          fechaFin
        }
      }
    }
  }
`);

export const GET_COMBINADOS_BY_FILTER_TO_PRODUCTO = gql(`
    query listadoCombinadosByFilter($filter: [String], $sort: [String], $page: Int!, $size: Int!) {
      listadoCombinadosByFilter(criteria: {filter: $filter, sort: $sort, page: $page, size: $size}) {
        results {
          id
          codigoProducto: codigo
          literalProductoTipo: tipo
          nombre
          fechaFin
          contadorUsos
          numeroUsos     
          literalProductoValor: nombre  
          contrato {
            fechaInicio
            fechaFin
            tipo
            iban
            contrato{
              fechaFin
            }
        }
        }
      }
    }
`);

export const GET_BONOS_BY_ID_LEGAL_CLIENTE = gql(`
  query listadoBonosByIdLegal($idLegalCliente: String ) {
    listadoBonosByIdLegal(idLegalCliente: $idLegalCliente) {
      id
      nombre
      tipo
      fechaAlta
      fechaFin
      numeroUsos
      contadorUsos
      avisoAlPorcentajeUsos
      tipoBono
      contrato{
        id
        fechaInicio
        fechaFin
      }
    }
  }
`);

export const MODIFICA_AVISO_LIMITE_USUOS = gql(`
    mutation EditarAvisoLimiteUsos($editarAvisoLimiteUsosRequest: EditarAvisoLimiteUsosRequestInput) {
      editarAvisoLimiteUsos(editarAvisoLimiteUsosRequest: $editarAvisoLimiteUsosRequest) {
        id
        nombre
        tipo
        fechaAlta
        fechaFin
        numeroUsos
        contadorUsos
        avisoAlPorcentajeUsos
        tipoBono
        }
    }
`);